/**
 * Lightweight trace ID generator for correlating frontend and backend logs.
 * Uses crypto.randomUUID when available, falling back to a timestamp-based ID.
 * The fallback keeps this portable to React Native (Hermes lacks randomUUID).
 */
export function generateTraceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const now = Date.now().toString(16);
  const random = Math.floor(Math.random() * 0xffffffff)
    .toString(16)
    .padStart(8, '0');
  return `${now}-${random}`;
}
